<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row class="bg-kiri black--text" no-gutters>
          <v-col cols="2" class="mt-5">&nbsp;</v-col>
          <v-col cols="10" class="pa-5" style="background-color: white">
            <h1 class="headline info--text mb-2">
              <v-row dense>
                <v-col cols="12">
                  Selamat Datang, <strong>{{ ptk.nama }}</strong>
                </v-col>
              </v-row>
            </h1>
            <h3 class="black--text my-2">Program Sekolah Penggerak</h3>
            <p class="body-2 mb-2">
              Anda termasuk calon peserta sekolah penggerak sasaran <strong>Angkatan 3.</strong> Untuk melihat informasi
              lebih lengkap mengenai daerah sasaran, silahkan klik <a href="" target="_blank">disini</a>
            </p>
            <template v-if="Number(ajuan && ajuan.is_sesuai) !== 1">
              <v-alert icon="mdi-information" elevation="0" class="yellow lighten-4">
                <h3>Data DAPODIK Tidak Sesuai</h3>
                <p class="body-2 text-justify">
                  Data Anda yang saat ini terhubung dengan DAPODIK telah Anda konfirmasi belum sesuai berdasarkan
                  pendaftaran yang telah Anda lakukan sebelumnya. Ikuti langkah-langkah berikut:
                </p>
                <ol class="body-2 mb-0">
                  <li>Segera lakukan update data Dapodik Anda melalui Operator Sekolah atau Operator Dinas.</li>
                  <li>
                    Estimasi waktu update di DAPODIK adalah 2x24 jam setelah Operator Dinas melakukan perubahan.
                  </li>
                  <li>
                    Cek sekala berkala apabila data sudah termutahirkan di DAPODIK, maka otomatis di SIMPKB akan ikut
                    berubah
                  </li>
                  <li>
                    Hubungi Admin SIMPKB Dinas Pendidikan untuk menyetujui perubahan data melalui aplikasi SIM Progam
                    Sekolah Penggerak
                  </li>
                  <li>Coba kembali untuk melakukan pendaftaran</li>
                </ol>
              </v-alert>
            </template>
            <template v-else>
              <p class="mb-0">
                Saat ini sekolah Anda <strong>Sudah Terdaftar Dalam Program Sekolah Penggerak.</strong> Untuk
                melanjutkan ke tahapan selanjutnya, silakan lakukan langkah berikut:
              </p>
              <ol style="padding-inline-start: 18px">
                <li>Unduh format pakta integritas di bawah ini, kemudian dicetak serta diisi.</li>
                <li>UNggah hasil isian berkas Anda pada bagian unggah berkas.</li>
                <li>Klik tombol kirim untuk mengirimkan berkas pakta integritas</li>
              </ol>
              <div class="mt-3">
                <v-btn class="mr-3 info" depressed elevation="0" @click="onDownloadTemplate">
                  Unduh Format
                  <v-icon right dark>
                    mdi-download
                  </v-icon>
                </v-btn>
                <v-btn class="mr-3 info" depressed elevation="0" @click="onUploadPakta">
                  Unggah Berkas
                  <v-icon right dark>
                    mdi-upload
                  </v-icon>
                </v-btn>
                <v-btn
                  class="mr-3 info"
                  depressed
                  elevation="0"
                  :href="ajuan.url_pakta"
                  :disabled="!ajuan.url_pakta"
                  target="_blank"
                >
                  Lihat Berkas
                  <v-icon right dark>
                    mdi-eye
                  </v-icon>
                </v-btn>
              </div>
              <v-alert dense text color="success" class="mt-4">
                <p class="body-2 black--text mb-1">
                  Jika Anda yakin berkas yang Anda unggah sudah sesuai, silakan kirimkan berkas Anda dengan menekan
                  tombol
                  <strong>Kirim Berkas</strong> di bawah
                </p>
                <v-btn
                  class="mr-3 green white--text"
                  depressed
                  elevation="0"
                  :disabled="!ajuan.url_pakta"
                  @click="onKirim"
                >
                  Kirim Berkas
                  <v-icon right dark>
                    mdi-send
                  </v-icon>
                </v-btn>
              </v-alert>
              <v-alert dense text type="error" class="mt-2">
                Atau jika Anda ingin batal daftar dikarenakan mengalami kendala satuan pendidikan berubah sehingga isian
                validasi dapodik dan template pakta integritas berbeda dengan kondisi di dapodik.
                <a style="font-weight: bold; text-decoration: underline" @click="onBatalDaftar">Batal Pendaftaran</a>
              </v-alert>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <base-modal-full ref="modal" generalError :title="formulir.title" @close="onClosePakta" @save="onSavePakta">
      <form-unggah
        labelColor="info"
        ref="formulir"
        :detail="formulir.detail"
        :title="formulir.title"
        :subtitle="formulir.subtitle"
        :deskripsi="formulir.deskripsi"
        :max="formulir.max"
        :format="formulir.format"
        :rules="formulir.rules"
        uimodel="card"
      >
      </form-unggah>
    </base-modal-full>
  </div>
</template>

<script>
import FormUnggah from '@components/form/Unggah';
import mixinAction from '@mixins/action';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'Ajuan',
  components: { FormUnggah },
  mixins: [mixinAction],
  computed: {
    ...mapState('preferensi', {
      ptk: (state) => state.data?.ptk ?? {},
      ajuan: (state) => state.data?.peserta_ajuan ?? {},
    }),
  },
  data() {
    return {
      formulir: {},
    };
  },
  methods: {
    ...mapActions('preferensi', ['templatePakta', 'uploadPakta', 'kirimPakta', 'daftarBatal']),

    onDownloadTemplate() {
      this.templatePakta().then((url) => {
        this.$downloadFile(process.env.VUE_APP_API_URL + '/' + url);
      });
    },

    onUploadPakta() {
      const detail = {
        label: 'file_pakta',
        title: 'Pakta',
      };

      this.$set(this.formulir, 'title', `Formulir Unggah Pakta`);
      this.$set(this.formulir, 'type', 'file_pakta');
      this.$set(this.formulir, 'format', `harus bertipe PDF`);
      this.$set(this.formulir, 'rules', { format: 'PDF', required: true });
      this.$set(this.formulir, 'mode', 'upload');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'max', 1500);
      this.$set(this.formulir, 'detail', detail);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onSavePakta() {
      const params = this.$refs.formulir.form || {};
      let formData = new FormData();

      formData.append('file_pakta', params.file);
      this.uploadPakta({ params: formData })
        .then(() => {
          this.$success(`Berkas berhasil diunggah`);
          this.$refs.modal.close();
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onClosePakta() {
      this.$refs.modal.dialog = false;
    },

    onKirim() {
      this.$confirm(`<h3>Anda yakin ingin mengajukan Berkas Pakta sekarang?</h3>`, `Kirim Berkas`, {
        tipe: 'success',
      }).then(() => {
        this.kirimPakta().then(() => {
          this.$success(`Berkas berhasil dikirim`);
          window.location.reload();
        });
      });
    },

    onBatalDaftar() {
      this.$confirm(`<h3>Anda yakin ingin Batal Pendaftaran?</h3>`, `Batal Pendaftaran`, {
        tipe: 'error',
      }).then(() => {
        this.daftarBatal().then(() => {
          this.$success(`Pendaftaran Anda berhasil dibatalkan`);
          window.location.reload();
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
